(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    window.CartDrawer = {
    open: () => {
      // document.getElementById('CartDrawer')?.classList.add('cart-drawer--active');
      // document.body.style.overflow = 'hidden';
      handleFloCartBtn();
    },
    close: () => {
      document.getElementById('CartDrawer')?.classList.remove('cart-drawer--active');
      document.body.style.overflow = '';
    },
    init: () => {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer || drawer._cartInitialized) return;
      drawer._cartInitialized = true;

      drawer.addEventListener('click', (e) => {
        const target = e.target.closest('.quantity-button, .cart-drawer__item-remove');
        if (!target || !target.dataset.id) return;

        const id = target.dataset.id;
        const action = target.dataset.action;

        if (target.classList.contains('quantity-button')) {
          const input = target.closest('.quantity-selector')?.querySelector('input');
          let quantity = parseInt(input?.value ?? 1);
          if (action === 'plus') quantity++;
          else if (action === 'minus' && quantity > 0) quantity--;
          window.CartDrawer.update(id, quantity);
        } else if (target.classList.contains('cart-drawer__item-remove')) {
          window.CartDrawer.update(id, 0);
        }
      });
    },
    update: async (id, quantity) => {
      const drawer = document.getElementById('CartDrawer');
      const body = drawer?.querySelector('.cart-drawer__body');
      
      try {
        if (body) body.classList.add('is-loading');
        
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            id, 
            quantity,
            sections: 'header'
          })
        });
        
        const data = await res.json();
        
        if (res.ok) {
          document.dispatchEvent(new CustomEvent('cart:updated', { 
            detail: { 
              cart: data,
              sections: data.sections
            } 
          }));
          
          if (window.showToast) {
            const message = quantity === 0 ? 'Item removed' : 'Cart updated';
            window.showToast(message, 'shopping-cart');
          }
        } else {
          throw new Error(data.description || 'Update failed');
        }
      } catch (e) {
        if (window.showToast) {
          window.showToast(e.message, 'alert-circle');
        }
      } finally {
        if (body) body.classList.remove('is-loading');
      }
    }
  };

  window.injectCartHtml = (html) => {
    if (!html) return;
    const newDoc = new DOMParser().parseFromString(html, 'text/html');
    const drawer = document.getElementById('CartDrawer');
    const newContent = newDoc.getElementById('CartDrawerContent');
    const currentContent = document.getElementById('CartDrawerContent');
    const newHeader = newDoc.querySelector('.cart-drawer__header');
    const currentHeader = drawer?.querySelector('.cart-drawer__header');
    const newFooter = newDoc.querySelector('.cart-drawer__footer');
    const currentFooter = drawer?.querySelector('.cart-drawer__footer');
    const newProgress = newDoc.getElementById('CartDrawerProgress');
    const currentProgress = document.getElementById('CartDrawerProgress');

    if (newHeader && currentHeader) {
      currentHeader.innerHTML = newHeader.innerHTML;
    }

    if (newProgress && currentProgress) {
      currentProgress.innerHTML = newProgress.innerHTML;
    }

    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }
    
    if (newFooter && currentFooter) {
      currentFooter.innerHTML = newFooter.innerHTML;
    } else if (newFooter && !currentFooter && drawer) {
      drawer.querySelector('.cart-drawer__inner').appendChild(newFooter);
    } else if (!newFooter && currentFooter) {
      currentFooter.remove();
    }
  };

  // The Drawer Component's own listener
  let _cartUpdateTimer = null;
  document.addEventListener('cart:updated', (e) => {
    window.CartDrawer.open();

    clearTimeout(_cartUpdateTimer);
    _cartUpdateTimer = setTimeout(() => {
      if (e.detail?.sections && e.detail.sections['header']) {
        window.injectCartHtml(e.detail.sections['header']);
      } else {
        fetch('/?section_id=header')
          .then(res => res.text())
          .then(html => window.injectCartHtml(html));
      }
    }, 50);
  });

  // Global trigger listener (Decoupled & Robust)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('#CartTrigger, #CartTriggerMobile');
    if (trigger) {
      e.preventDefault();
      window.CartDrawer?.open();
    }
  });

  // Setup close buttons/overlay via delegation (survives innerHTML replacement)
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    drawer.addEventListener('click', (e) => {
      if (e.target.closest('.cart-drawer__close')) window.CartDrawer.close();
    });
    drawer.querySelector('.cart-drawer__overlay')?.addEventListener('click', window.CartDrawer.close);
    window.CartDrawer.init();
  });

  // ── Gift Wrap Modal ──────────────────────────────────────────────────────
  window.GiftWrap = {
    _selectedVariantId: null,
    _selectedVariantPrice: 0,

    open: async () => {
      const modal = document.getElementById('GiftWrapModal');
      if (!modal) return;

      // Reset state
      window.GiftWrap._selectedVariantId = null;
      window.GiftWrap._selectedVariantPrice = 0;
      document.getElementById('GiftWrapConfirm').disabled = true;

      // Show modal (loading state)
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('giftwrap-modal--active');
      document.getElementById('GiftWrapVariants').innerHTML = '<div class="giftwrap-modal__loading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide spin" aria-hidden="true"><path d="M12 2v4"/><path d="m16.2 7.8 2.9-2.9"/><path d="M18 12h4"/><path d="m16.2 16.2 2.9 2.9"/><path d="M12 18v4"/><path d="m4.9 19.1 2.9-2.9"/><path d="M2 12h4"/><path d="m4.9 4.9 2.9 2.9"/></svg></div>';

      try {
        const res = await fetch('/products/gift-wrapping.js');
        if (!res.ok) throw new Error('Product not found');
        const product = await res.json();
        window.GiftWrap._renderVariants(product.variants);
      } catch {
        document.getElementById('GiftWrapVariants').innerHTML = '<p class="giftwrap-modal__error">Gift wrapping options unavailable.</p>';
      }
    },

    close: () => {
      const modal = document.getElementById('GiftWrapModal');
      if (!modal) return;
      modal.classList.remove('giftwrap-modal--active');
      modal.setAttribute('aria-hidden', 'true');
    },

    _renderVariants: (variants) => {
      const container = document.getElementById('GiftWrapVariants');
      if (!variants || variants.length === 0) {
        container.innerHTML = '<p class="giftwrap-modal__error">No gift wrapping options available.</p>';
        return;
      }

      container.innerHTML = variants.map(v => `
        <button
          type="button"
          class="giftwrap-variant"
          data-variant-id="${v.id}"
          data-variant-price="${v.price}"
          aria-pressed="false"
        >
          ${v.featured_image ? `<div class="giftwrap-variant__image"><img src="${v.featured_image.src}" alt="${v.title}" loading="lazy"></div>` : '<div class="giftwrap-variant__image giftwrap-variant__image--placeholder"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg></div>'}
          <div class="giftwrap-variant__info">
            <span class="giftwrap-variant__name">${v.title}</span>
            <span class="giftwrap-variant__price">${window.GiftWrap._formatMoney(v.price)}</span>
          </div>
          <div class="giftwrap-variant__check" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
          </div>
        </button>
      `).join('');

      container.addEventListener('click', (e) => {
        const btn = e.target.closest('.giftwrap-variant');
        if (!btn) return;

        container.querySelectorAll('.giftwrap-variant').forEach(b => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');

        window.GiftWrap._selectedVariantId = btn.dataset.variantId;
        window.GiftWrap._selectedVariantPrice = parseInt(btn.dataset.variantPrice, 10);
        document.getElementById('GiftWrapConfirm').disabled = false;
      });
    },

    _formatMoney: (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat('en', { style: 'currency', currency }).format(cents / 100);
    },

    addAndCheckout: async () => {
      const confirmBtn = document.getElementById('GiftWrapConfirm');
      confirmBtn.disabled = true;
      confirmBtn.querySelector('span').textContent = 'Adding…';

      try {
        // Count non-gift-wrap items to determine quantity
        const cartRes0 = await fetch('/cart.js');
        const currentCart = await cartRes0.json();
        const qty = currentCart.items
          .filter(item => item.handle !== 'gift-wrapping')
          .reduce((sum, item) => sum + item.quantity, 0);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: window.GiftWrap._selectedVariantId, quantity: qty || 1 })
        });
        if (!res.ok) throw new Error('Could not add gift wrap');

        // Fetch updated cart to dispatch event + update subtotal
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

        // Update subtotal in footer (will also be replaced by injectCartHtml but let's be safe)
        const subtotalEl = document.getElementById('CartDrawerSubtotal');
        if (subtotalEl && cart.total_price != null) {
          const formatted = (cart.total_price / 100).toFixed(2);
          subtotalEl.textContent = `$${formatted}`;
        }

        window.GiftWrap.close();
        window.initiateShopfloCheckout();
      } catch (err) {
        if (window.showToast) window.showToast(err.message || 'Something went wrong', 'alert-circle');
        confirmBtn.disabled = false;
        confirmBtn.querySelector('span').textContent = 'Add gift wrap & checkout';
      }
    },

    _isAlreadyInCart: async () => {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        return cart.items.some(item => item.handle === 'gift-wrapping');
      } catch {
        return false;
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    // Intercept checkout form
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('#cart-drawer-form');
      if (!form) return;
      e.preventDefault();

      // Skip popup if gift wrap already in cart
      const alreadyAdded = await window.GiftWrap._isAlreadyInCart();
      if (alreadyAdded) {
        window.initiateShopfloCheckout();
        return;
      }

      window.GiftWrap.open();
    });

    // Gift wrap modal buttons
    document.addEventListener('click', (e) => {
      if (e.target.closest('#GiftWrapConfirm')) {
        window.GiftWrap.addAndCheckout();
      }
      if (e.target.closest('#GiftWrapSkip')) {
        window.GiftWrap.close();
        window.initiateShopfloCheckout();
      }
      if (e.target.closest('.giftwrap-modal__backdrop')) {
        window.GiftWrap.close();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.quickAddInitialized) {
    document.addEventListener('click', async (e) => {
      const button = e.target.closest('.js-quick-add');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = button.dataset.variantId;
      button.classList.add('is-loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        const data = await response.json();

        if (response.ok) {
          button.classList.remove('is-loading');
          button.classList.add('is-success');

          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (window.showToast) window.showToast('Item added to cart', 'shopping-cart');

          setTimeout(() => {
            button.classList.remove('is-success');
          }, 2000);
        } else {
          // Handle Shopify specific errors (e.g. 422 Unprocessable Entity)
          button.classList.remove('is-loading');
          
          if (window.showToast) {
            const errorMessage = data.description || data.message || 'Could not add to cart';
            window.showToast(errorMessage, 'alert-circle');
          }
        }
      } catch (err) {
        console.error('Quick add error:', err);
        button.classList.remove('is-loading');
        if (window.showToast) {
          window.showToast('An unexpected error occurred', 'alert-triangle');
        }
      }
    });
    window.quickAddInitialized = true;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-customisation"] && !Shopify.designMode) return;
  try {
    window.ProductCustomisation = (function () {
    const STORAGE_KEY = 'pc_values';

    let _fields      = [];
    let _values      = {};   // persisted by field id across variant switches
    let _valid       = true; // true when no required fields or all filled
    let _initialized = false;

    function _loadValues() {
      try { _values = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); } catch { _values = {}; }
    }

    function _saveValues() {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(_values)); } catch {}
    }

    function _getCustomisationData() {
      try {
        return JSON.parse(document.getElementById('variant-customisation-data')?.textContent || '{}');
      } catch { return {}; }
    }

    function _isFieldVisible(field) {
      if (!field.visible_if) return true;
      const controlValue = (_values[field.visible_if.field] || '').trim();
      return controlValue === field.visible_if.value;
    }

    function _applyVisibility() {
      _fields.forEach(field => {
        const wrapper = document.querySelector(`.customisation-field[data-field-id="${field.id}"]`);
        if (!wrapper) return;
        const visible = _isFieldVisible(field);
        wrapper.style.display = visible ? '' : 'none';
        const el = document.getElementById('customisation-' + field.id);
        if (el) el.disabled = !visible;
      });
      _validate();
    }

    function _validate() {
      _valid = _fields
        .filter(f => f.required && _isFieldVisible(f))
        .every(f => (_values[f.id] || '').trim() !== '');

      document.dispatchEvent(new CustomEvent('customisation:validated', { detail: { valid: _valid } }));
      return _valid;
    }

    function _render(variantId) {
      const wrapper = document.getElementById('ProductCustomisation');
      const container = document.getElementById('ProductCustomisationFields');
      if (!wrapper || !container) return;

      const data = _getCustomisationData();
      _fields = data[variantId] || [];

      if (_fields.length === 0) {
        wrapper.style.display = 'none';
        _valid = true;
        document.dispatchEvent(new CustomEvent('customisation:validated', { detail: { valid: true } }));
        return;
      }

      wrapper.style.display = 'block';

      container.innerHTML = _fields.map(field => _buildField(field)).join('');

      // Restore persisted values
      _fields.forEach(field => {
        const el = document.getElementById('customisation-' + field.id);
        if (el && _values[field.id] != null) {
          el.value = _values[field.id];
          if (field.max_length) _updateCounter(field);
        }
      });

      // Bind events
      _fields.forEach(field => {
        const el = document.getElementById('customisation-' + field.id);
        if (!el) return;
        el.addEventListener('input', () => _onFieldInput(field, el));
        el.addEventListener('blur',  () => _onFieldBlur(field, el));
      });

      _applyVisibility();
    }

    function _buildField(field) {
      const requiredMark = field.required
        ? '<span class="customisation-field__required" aria-label="required">*</span>'
        : '';

      let control = '';

      if (field.type === 'dropdown') {
        const opts = (field.options || []).map(opt =>
          `<option value="${_esc(opt)}">${_esc(opt)}</option>`
        ).join('');
        control = `
          <select
            id="customisation-${field.id}"
            name="properties[${_esc(field.label)}]"
            class="customisation-field__select"
            ${field.required ? 'required' : ''}
            aria-required="${!!field.required}"
          >
            <option value="">— Select an option —</option>
            ${opts}
          </select>`;

      } else if (field.type === 'textarea') {
        control = `
          <textarea
            id="customisation-${field.id}"
            name="properties[${_esc(field.label)}]"
            class="customisation-field__textarea"
            placeholder="${_esc(field.placeholder || '')}"
            ${field.required ? 'required' : ''}
            aria-required="${!!field.required}"
            ${field.max_length ? `maxlength="${field.max_length}"` : ''}
            rows="3"
          ></textarea>`;

      } else {
        // default: text
        control = `
          <input
            type="text"
            id="customisation-${field.id}"
            name="properties[${_esc(field.label)}]"
            class="customisation-field__input"
            placeholder="${_esc(field.placeholder || '')}"
            ${field.required ? 'required' : ''}
            aria-required="${!!field.required}"
            ${field.max_length ? `maxlength="${field.max_length}"` : ''}
          >`;
      }

      const counterHtml = field.max_length
        ? `<span class="customisation-field__counter" id="counter-${field.id}" aria-live="polite">0 / ${field.max_length}</span>`
        : '';

      const helperHtml = field.helper_text
        ? `<span class="customisation-field__helper">${_esc(field.helper_text)}</span>`
        : '';

      return `
        <div class="customisation-field" data-field-id="${field.id}">
          <label class="customisation-field__label" for="customisation-${field.id}">
            ${_esc(field.label)}${requiredMark}
          </label>
          ${control}
          ${helperHtml}
          <div class="customisation-field__meta">
            <span class="customisation-field__error" id="error-${field.id}" role="alert"></span>
            ${counterHtml}
          </div>
        </div>`;
    }

    function _onFieldInput(field, el) {
      _values[field.id] = el.value;
      _saveValues();
      el.classList.remove('has-error');
      document.getElementById('error-' + field.id).style.display = 'none';
      if (field.max_length) _updateCounter(field);
      _applyVisibility();
    }

    function _onFieldBlur(field, el) {
      if (field.required && el.value.trim() === '') {
        el.classList.add('has-error');
        const errEl = document.getElementById('error-' + field.id);
        errEl.textContent = field.label + ' is required';
        errEl.style.display = 'block';
      }
    }

    function _updateCounter(field) {
      const el = document.getElementById('customisation-' + field.id);
      const counterEl = document.getElementById('counter-' + field.id);
      if (!el || !counterEl) return;
      const len = el.value.length;
      counterEl.textContent = len + ' / ' + field.max_length;
      counterEl.classList.toggle('is-over', len > field.max_length);
    }

    function _esc(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function init() {
      if (_initialized) return;
      _initialized = true;

      _loadValues();

      // Initial render for the already-selected variant
      const variantInput = document.getElementById('variant-id-input');
      if (variantInput && variantInput.value) {
        _render(variantInput.value);
      }

      // Re-render on every subsequent variant switch
      document.addEventListener('variant:changed', (e) => {
        _render(String(e.detail.variant.id));
      });
    }

    // Self-initialise: handle both cases where DOM is already ready or not yet
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    return {
      init,
      isValid() { return _valid; },
      getProperties() {
        const props = {};
        _fields.forEach(f => {
          if (!_isFieldVisible(f)) return;
          const val = (_values[f.id] || '').trim();
          if (val) props[f.label] = val;
        });
        return props;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
